module.exports = __webpack_public_path__ + "img/info20@3x.990bc8af.png";